var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasConsent)?_c('wac-cms-consent-notification'):_c('wac-media-player',_vm._b({staticClass:"wac-cms-video",on:{"source-selected":_vm.onSourceSelected,"media-ready":_vm.onMediaReady}},'wac-media-player',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }